import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { User } from '../_models/user';

import { AuthenticationService } from '../_services/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal
  ) {}

  exceptions = ['search', 'rooms', 'reports'];

  exceptionExists(route) {
    console.log(`authGuard: Checking if exception exists - ${route}`);
    if (this.exceptions.indexOf(route) >= -1) {
      console.log('Exception exists');
      return true;
    } else {
      console.log("Exception doesn't exist");
      return false;
    }
  }

  canGoToRoute(user: User, route): boolean {
    let permissions = this.authenticationService.userPermissions;
    if (!permissions) {
      const userFromLocalStorage: User = JSON.parse(
        localStorage.getItem('currentUser')
      );
      permissions = userFromLocalStorage.role.permissions;
      this.authenticationService.permissions$.next(permissions);
    }

    console.log('route:', route, permissions[route]);
    if (
      this.exceptionExists(route) ||
      (permissions[route] && permissions[route]['read'] === true)
    ) {
      return true;
    } else {
      return false;
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.modalService.dismissAll();

    const currentUser = this.authenticationService.currentUserValue;

    if (currentUser) {
      if (
        this.canGoToRoute(currentUser, state.url.split('/')[1].split('?')[0])
      ) {
        return true;
      } else {
        this.router.navigate(['/not-allowed']);
        return true;
      }
    }
    console.log('Not logged in');
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/auth/login']);
    return true;
  }
}
